import { formatPhoneNumber } from "@xola/ui-kit";
import { RowData } from "./types";

export const phoneCellValueGetter = ({ data }: { data: RowData }) => {
    if ("balance" in data) {
        return null;
    }

    const { phone } = data.item.purchase;
    const phoneField = data.guest?.formResponse?.fields.find((field) => /phone/i.test(field.label));
    const value = data.isOrganizer ? phone ?? null : phoneField?.value ?? null;

    return value ? formatPhoneNumber(value) : null;
};

export const PhoneCellFormatter = ({ value }: { value: string | null }) => value ?? "";
